import styled from '@emotion/styled';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import * as colors from 'src/assets/colors';

export const ConfigContainer = styled('div', { label: 'ConfigContainer' })`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0;
`;

export const ConfigRow = styled('div', { label: 'ConfigRow' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${colors.licenseConfig.borderColorSecondary};
    padding: 5px 0;

    &:last-child {
        border-bottom: none;
    }
`;

export const ConfigLabel = styled('div', { label: 'ConfigLabel' })`
    font-size: ${fontSize.regular};
    font-weight: ${fontWeight.medium};
    color: ${colors.licenseConfig.txtColorSecondary};
    flex: 1;
    padding-right: 16px;
`;

export const ConfigValueCell = styled('div', { label: 'ConfigValueCell' })`
    font-size: ${fontSize.regular};
    font-weight: ${fontWeight.medium};
    color: ${colors.licenseConfig.txtColor};
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-shrink: 0;
`;


export const CurrencyPrefix = styled('span', { label: 'CurrencyPrefix' })`
    font-size: ${fontSize.regular};
    font-weight: ${fontWeight.medium};
    color: ${colors.licenseConfig.txtColor};
    flex-shrink: 0;
`;

export const SubmitButtonWrapper = styled('div', { label: 'SubmitButtonWrapper' })`
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
`;
